import axios from 'axios'
import moment from 'moment';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useHistory, useParams } from 'react-router'
import { authContext } from '../../context/AuthContext'
import Loading from '../helper/Loading';
import PageHeader from '../helper/PageHeader';
import SimpleTable from '../helper/SimpleTable';
import UserInfoDisplay from '../helper/UserInfoDisplay';
import { withTranslation } from 'react-i18next';
import { zoomOnlyCourseId  } from '../../constants/global'

// if from dashboard, user is authContext. if from admin, user is from location state or param
const TrainingHist =  props => {
    const from = props.from // "dashboard" or "admin"
    const history = useHistory()
    const { t } = props;
    const userMain = useContext(authContext)

    //const locState = history.location.state
    const mounted = useRef(true)
    const params = useParams()
    
    const tableCells = [
        { id: 'courseLabel', label: t('TrainingHistoryCard.Course'), centered: false },
        { id: 'type', label: t('TrainingHistoryCard.TrainingType'), centered: false },
        { id: 'status', label: t('TrainingHistoryCard.Status'), centered: false },
        { id: 'registerDateFormatted', label: t('TrainingHistoryCard.DateRegistered'), centered: false },
        { id: 'certID', label: t('TrainingHistoryCard.CertID'), centered: false },
        { id: 'disabledText', label: t('TrainingHistoryCard.Disabled'), centered: false }
    ];


 

    const [tableData, setTableData] = useState(null)
    // user account info from the get request
    const [userData, setUserData] = useState({ DOB: null, email: null, first_name: null, last_name: null, middle_name: null, username: null }) 

    const username = params.username

    async function getData() {
        const res = await axios.all([
            axios.get('/api/userTraining/all/' + username),
            axios.get('/api/user/info/' + username)
        ])

        console.log("RES", res)

        if (mounted.current) {
            const trainData = res[0].data.trainings.map(e => { 
                e.registerDateFormatted = moment(e.registerDate).format('YYYY-MM-DD hh:mm:ss A')
                e.certDate = moment(e.certDate).format('YYYY-MM-DD hh:mm:ss A')
                e.status = (e.courseId === zoomOnlyCourseId) ? t('trainingStatus.Status', { context: "Attended" }) :  t('trainingStatus.Status', { context: e.status }) 
                e.disabledText = e.disabled ? 'YES' : 'No'
                e.actionsDisabled = {
                    // only avaiable if admin && not disabled trainining
                    allowDisable: from === "admin" && e.disabled !== true ? true : false, 
                    allowEnable: from === "admin" && e.disabled === true ? true : false, 
                    allowView :  from !== "admin"  && e.disabled ? false: true,
                    allowRequestCertificate : e.status === 'Passed' && e.disabled !== true, //e.certID !== null,
                    allowDownloadCertificate: e.certID !== null

                } 
                return e
            })
            console.log('train Data', trainData)
            setTableData(trainData)
            setUserData(res[1].data.user)
        }

    }



    useEffect(() => {
       

        getData()

        

        return () => mounted.current = false
    }, [])

    const onView = async (id) => {
        const training = tableData.find(e => e.id === id)
        const to = from === "admin" ? "administration/users/" + username : "dashboard"

        const regTime6Mo = moment(training.registerDate).add(6, 'months')
        const timeLeft = regTime6Mo.diff(moment(), 'days')
        const expired = timeLeft < 0

        // this part is enabled if dashboard and not expired
        if (from === "dashboard" && !expired) {
            const res = await axios.get('/api/course/' + training.courseId)
            const modules = res.data.modules
            console.log(res)
            history.push('/training', { fromView: true, trainingId: id, id: training.courseId, label: training.courseLabel, modules, type: training.type, certLink: res.data.course.postTestLink, serialNum: training.serialNumber })

        } else { // otherwise it goes to the view details portion
            history.push('/' + to + '/trainingHistory/details', {
                trainingId: id,
                username: username,
                courseID: training.courseId,
                courseLabel: training.courseLabel,
                courseType: training.type
            })
        }
    }

    const onDisable = async (id) => {
        if (from === "admin" ) {
        const token = userMain.accessToken
            
        const res = await axios.post('/api/userTraining/setDisabled/' + id, 
            {
                disabled: true
            }, {
            headers: {
                Authorization: token
            }
        })
        if (res.status === 200) {
            getData()
            }
        }
    }


    const onEnable = async (id) => {
        if (from === "admin" ) {
            const token = userMain.accessToken
            
            const res = await axios.post('/api/userTraining/setDisabled/' + id, 
                {
                    disabled: false
                }, {
                headers: {
                    Authorization: token
                }
            })
        if (res.status === 200) {
            getData()
            }
        }
    }

    const onRequestCertificate = (id) => {
        console.log('id', id)
        let filteredCertificate = tableData.filter( data => data.id=== id )
        // console.log('filtered ', filteredCertificate)
        history.push('/dashboard/userCertificateRequest/' + params.username, {
            certID: filteredCertificate[0].certID,
            certDate: filteredCertificate[0].certDate
        } )
        
        // setDialogOpen(true)
    

    }

    const actionButtons = [
        { icon: "view", label: t('TrainingHistoryCard.Details'), action: onView, delete: false, view: "allowView" },
        { icon: "remove", label: t('TrainingHistoryCard.Disable'), action: onDisable, delete: true, view: "allowDisable"  },
        { icon: "add", label: t('TrainingHistoryCard.Enable'), action: onEnable, delete: true, view: "allowEnable"  },
        { icon: "requestcertificate", label: 'Certificate', action: onRequestCertificate, delete: false, view: "allowRequestCertificate"  },
    ];


    return (
        <>
            <PageHeader title={t('TrainingHistoryCard.TrainingHistory')} backButton />
            {tableData === null ?
                <Loading /> :
                <>
                    <UserInfoDisplay userData={userData} />

                    <SimpleTable
                        data={tableData}
                        cellKey={"id"}
                        tableCells={tableCells}
                        actionButtons={actionButtons}
                        actions={true}
                    />
                </>
            }
        </>
    )
}

export default withTranslation()(TrainingHist);
